import React, { Fragment, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Row, Col, Card } from 'react-bootstrap';
import FooterNote from 'components/footer/footerNote';
import InsightsLoader from 'components/loaders/InsightsLoader';
import CoursesOverview from 'pages/insights/containers/coursesAnalyticsContainer/components/coursesOverview';
import DownloadCoursesAnalytics from 'pages/insights/containers/coursesAnalyticsContainer/components/downloadCoursesAnalytics';
import { coursesAnalyticsActions } from 'pages/insights/containers/coursesAnalyticsContainer/actions';
import { analyticsSummaryActions } from 'pages/insights/containers/analyticsSummaryContainer/actions';
import { getCurrentSiteLearnerHistory } from 'selectors';
import ActiveCourses from 'pages/insights/containers/analyticsSummaryContainer/components/activeCourses';
import CoursesCompletions from 'components/coursesCompletions';
import DateFilter from 'components/dateFilter';
import TotalCourses from 'pages/insights/containers/analyticsSummaryContainer/components/totalCourses';
import { quickStatsActions } from 'pages/dashboard/containers/quickStats/actions/quickStats';

const moment = require('moment');

const CoursesAnalytics = (props) => {
  const { dispatch, site_history } = props;

  const defaultState = {
    filter_type: 'this_year',
    filter_start_date: moment().subtract(1, 'months'),
    filter_end_date: moment()
  };
  const [AnalyticsSummaryFilterType, setAnalyticsSummaryFilterType] = useState(defaultState.filter_type);
  const [AnalyticsSummaryFilterStartDate, setAnalyticsSummaryFilterStartDate] = useState(
    defaultState.filter_start_date
  );
  const [AnalyticsSummaryFilterEndDate, setAnalyticsSummaryFilterEndDate] = useState(defaultState.filter_end_date);

  const handleFilterChange = (value) => {
    setAnalyticsSummaryFilterType(value);
  };

  const handleSetStartDate = (date) => {
    setAnalyticsSummaryFilterStartDate(date);
  };

  const handleSetEndDate = (date) => {
    setAnalyticsSummaryFilterEndDate(date);
  };

  const handleRefresh = (e) => {
    e.preventDefault();
    dispatch(
      analyticsSummaryActions.fetchGeneralSiteMetrics({
        filter_type: AnalyticsSummaryFilterType,
        filter_start_date: AnalyticsSummaryFilterStartDate,
        filter_end_date: AnalyticsSummaryFilterEndDate
      })
    );
    dispatch(
      quickStatsActions.fetchCourseCompletionsQuickStats({
        filter_type: AnalyticsSummaryFilterType,
        filter_start_date: AnalyticsSummaryFilterStartDate,
        filter_end_date: AnalyticsSummaryFilterEndDate
      })
    );
  };

  const setDefaultFilter = (e) => {
    e.preventDefault();
    setAnalyticsSummaryFilterType(defaultState.filter_type);
    dispatch(
      analyticsSummaryActions.fetchGeneralSiteMetrics({
        ...defaultState
      })
    );
    dispatch(
      quickStatsActions.fetchCourseCompletionsQuickStats({
        ...defaultState
      })
    );
  };

  useEffect(() => {
    dispatch(coursesAnalyticsActions.fetchAllCoursesGeneralData());
    dispatch(
      analyticsSummaryActions.fetchGeneralSiteMetrics({
        filter_type: AnalyticsSummaryFilterType,
        filter_start_date: AnalyticsSummaryFilterStartDate,
        filter_end_date: AnalyticsSummaryFilterEndDate
      })
    );
    dispatch(
      quickStatsActions.fetchMAUSQuickStats({
        filter_type: AnalyticsSummaryFilterType,
        filter_start_date: AnalyticsSummaryFilterStartDate,
        filter_end_date: AnalyticsSummaryFilterEndDate
      })
    );
    dispatch(
      quickStatsActions.fetchCourseCompletionsQuickStats({
        filter_type: AnalyticsSummaryFilterType,
        filter_start_date: AnalyticsSummaryFilterStartDate,
        filter_end_date: AnalyticsSummaryFilterEndDate
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  return (
    <div className="courses-analytics" id="page_content">
      <div className="page-content-header">
        <h2 className="mb-lg-0">Courses Analytics</h2>
        <DownloadCoursesAnalytics />
      </div>
      <div className="mb-3">
        <DateFilter
          filterType={AnalyticsSummaryFilterType}
          handleRefresh={handleRefresh}
          handleFilterChange={handleFilterChange}
          handleSetStartDate={handleSetStartDate}
          handleSetEndDate={handleSetEndDate}
          setDefaultFilter={setDefaultFilter}
        />
      </div>
      {site_history ? (
        <>
          <Row className="stats-block mb-4">
            <Col xs="12" lg="4" className="mb-4 mb-lg-0">
              <CoursesCompletions show_chart="true" trending="true" title="Course Completions" />
            </Col>
            <Col xs="12" lg="4" className="mb-4 mb-lg-0">
              <TotalCourses />
            </Col>
            <Col xs="12" lg="4">
              <ActiveCourses />
            </Col>
          </Row>
        </>
      ) : (
        <Card height={100} className="mb-4 p-4">
          <InsightsLoader />
        </Card>
      )}

      <CoursesOverview />
      <FooterNote />
    </div>
  );
};

function mapStateToProps(state) {
  const site_history = getCurrentSiteLearnerHistory(state);

  return {
    site_history
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    ...bindActionCreators(analyticsSummaryActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CoursesAnalytics);
